import React from "react";
import TopBar from "../Components/TopBar";
import "../Style/login.css";
import FooterBottom from "../Components/FooterBottom";

function Login() {
  return (
    <div className="login">
      <div className="litopbar">
        <TopBar />
      </div>
      <div className="lihead">Login To Nairaland</div>
      <div className="li_sec">
        <div className="li_sec-head">Login With Password:</div>
        <div className="li_sec-bottom">
          <div className="li_sec-left">
            <span> User Name: </span> <input type="text" readOnly />
          </div>
          <div className="li_sec-right">
            <span>Password: </span>{" "}
            <input type="password" name="" id="" readOnly />
          </div>
          <button>Submit</button>
        </div>
      </div>
      <div className="li_down">
        <div className="li_down-top">Reset Your Password:</div>
        <div className="li_down-bottom">
          <div className="lidb_top">
            Please enter your email address and a link allowing you to reset
            your password will be emailed to you.
          </div>
          <div className="lidb_down">
            Email: <input type="email" name="" id="" readOnly />{" "}
            <button>Submit</button>
          </div>
        </div>
      </div>
      <div className="loginfoot">
        <FooterBottom />
      </div>
    </div>
  );
}

export default Login;
